module.exports = __webpack_public_path__ + "img/Huang_Huang.d73115e9.png";